// Generated by CoffeeScript 2.7.0
var Admin__Settings__RegisterController;

import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js';

import SettingsNavigator from 'trunks/vue/admin/compositions/settings_sidebar/settings_navigator.js';

import SettingsRegister from 'trunks/vue/admin/components/settings/settings_container/settings_register.js';

export default Admin__Settings__RegisterController = (function() {
  class Admin__Settings__RegisterController extends Skylark.App.BaseController {
    show() {
      this._generateSettingsSidebarView('settings__basic');
      return Skylark.Libs.Ajax.get('/admin/settings/register.json', {
        success: function(data) {
          return new SettingsRegister({
            el: DomMaster.find("#js-settings-register").node,
            propsData: {
              activeTab: 'register',
              register: data
            }
          });
        }
      });
    }

  };

  Admin__Settings__RegisterController.include(GenerateMorePopover);

  Admin__Settings__RegisterController.include(SettingsNavigator);

  return Admin__Settings__RegisterController;

}).call(this);
